import React from 'react';
import {
  type SelectroInlineItem,
  type SelectroState,
} from '@aha-app/selectro-v2';

const SelectroV2FilterTriggerTemplate: React.FC<{
  items: SelectroInlineItem[];
  state?: SelectroState;
  preScript?: string;
  className?: string;
}> = ({ items, preScript = '', className = '', state }) => {
  return (
    <button
      type='button'
      className={`selectro-trigger selectro-v2-template--filter-trigger ${className}`}
    >
      {preScript || state?.text?.preScript}
      {items.length > 0
        ? items
            .slice(0, 20)
            .map(item => item.text)
            .join(', ')
        : state?.text?.noneSelected}
    </button>
  );
};

export default SelectroV2FilterTriggerTemplate;
